import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { MaterialModule } from '../app-material.module';
import { SharedModule } from '../shared/shared.module';
import { IconComponent } from './components/icon/icon.component';
import { LinkFormComponent } from './components/link-form/link-form.component';
import { LinkItemComponent } from './components/link-item/link-item.component';
import { LinksPreviewComponent } from './components/links-preview/links-preview.component';
import { LinksComponent } from './links.component';

@NgModule({
  declarations: [
    LinksComponent,
    LinkItemComponent,
    LinkFormComponent,
    LinksPreviewComponent,
    IconComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    AngularSvgIconModule.forRoot(),
  ],
})
export class LinksModule {}
